import React from "react";
import {useTranslation} from "react-i18next";
//local
import {RadioGroup} from "components/RadioGroup";
import Upload from "components/Upload";

const QualificationAnswer = ({
  question,
  number,
  answer,
  onChange,
  onUploadFile,
  onChangeFiles,
  isAdminOwner,
  buyerSide,
  loading,
}) => {
  const {t} = useTranslation();

  const radioValues = [
    {
      value: true,
      label: "YES",
      checked: answer?.yes === true,
      disabled: loading || buyerSide,
    },
    {
      value: false,
      label: "NO",
      checked: answer?.yes === false,
      disabled: loading || buyerSide,
    },
  ];

  return (
    <div className="qualifications-answers-modal__answer-item">
      <div className="full-width">
        <div className="df-row">
          <span className="pr-4">{`${number + 1}. ${question.label}`}</span>
          <Upload
            variant="attachment"
            viewMode
            files={question.files ?? []}
            wrapperClass="ml-[-10]"
          />
        </div>
        <div className="df">
          <div className="mt-4">
            <div className="__uppercase __bold fz-10 mb-1">
              {t("QUALIFICATION_ANSWERS_MODAL_OUR_RESPONSE")}
            </div>
            <RadioGroup
              values={radioValues}
              large
              redDotIfNoValue
              colorizeDizabled
              resultValue={(value) =>
                onChange(
                  {
                    questionId: answer?.questionId ?? question.id,
                    yes: value,
                    files: answer?.files ?? [],
                  },
                  !answer?.questionId
                )
              }
            />
          </div>

          <div className="mt-7 ml-2">
            <Upload
              variant="attachment"
              viewMode={!isAdminOwner || buyerSide}
              files={answer?.files ?? []}
              uploadRequest={onUploadFile}
              onChange={(files) => onChangeFiles(files, question.id, !answer?.questionId)}
              disabledUpload={loading}
              needRemoveConfirm={false}
              customFileSize={102400}
              maxFilesCount={1}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualificationAnswer;
